import React from 'react';
import schools from 'assets/images/login/info/schools.png';
import olympiads from 'assets/images/login/info/olympiads.png';
import knowledge_monitoring from 'assets/images/login/info/knowledge_monitoring.png';
import webinars from 'assets/images/login/info/webinars.png';

export const circleTexts = [
  {
    image: {
      path: schools,
    },
    title: 'ШКОЛЫ',
    text: (
      <>
        Статистика по ученикам,
        <br /> учителям и школам в разрезе <br /> классов и предметов
      </>
    ),
    path: '/schools',
    id: 'schools',
  },
  {
    image: {
      path: olympiads,
    },
    title: 'ОЛИМПИАДЫ',
    text: (
      <>
        Расписание, а также статистика <br /> прошлых и текущих <br />
        соревнований
      </>
    ),
    path: '/olympiads',
    id: 'olympiads',
  },
  {
    image: {
      path: knowledge_monitoring,
    },
    title: 'СРЕЗЫ ЗНАНИЙ',
    text: (
      <>
        Качественные и<br /> количественные результаты тестирования
      </>
    ),
    path: '/knowledge_slices',
    id: 'knowledge_slices',
  },
  {
    image: {
      path: webinars,
    },
    title: 'ОБУЧЕНИЕ УЧИТЕЛЕЙ',
    text: (
      <>
        Расписание вебинаров и КПК <br /> для эффективной работы на платформе
      </>
    ),
    path: '/webinars',
    id: 'webinars',
  },
];
